import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CourseOfStudy } from '../../models/application/course-of-study.interface';
import { Observable, ReplaySubject } from 'rxjs';
import { first, flatMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CourseOfStudyService {
	$courseOfStudyData: Observable<CourseOfStudy>;
	$coursesOfStudyData: Observable<Array<CourseOfStudy>>;
	readonly courseOfStudyDataSubject: ReplaySubject<CourseOfStudy>;
	readonly coursesOfStudyDataSubject: ReplaySubject<Array<CourseOfStudy>>;

	constructor(private readonly http: HttpClient) {
		this.courseOfStudyDataSubject = new ReplaySubject<CourseOfStudy>(undefined);
		this.coursesOfStudyDataSubject = new ReplaySubject<Array<CourseOfStudy>>(undefined);
		this.$courseOfStudyData = this.courseOfStudyDataSubject.asObservable();
		this.$coursesOfStudyData = this.coursesOfStudyDataSubject.asObservable();
	}

	getProgramCoursesOfStudy(programId: number): Observable<Array<CourseOfStudy>> {
		return this.http.get<Array<CourseOfStudy>>(`programs/${programId.toString()}/courses-of-study`);
	}

	getApplicationCourseOfStudy(applicationId: number): Observable<CourseOfStudy> {
		return this.http.get<Array<CourseOfStudy>>(`applications/${applicationId.toString()}/courses-of-study`).pipe(
			flatMap((e) => e),
			first()
		);
	}

	updateApplicationCourseOfStudy(applicationId: number, courseOfStudy: CourseOfStudy): Observable<CourseOfStudy> {
		return this.http.put<CourseOfStudy>(
			`applications/${applicationId.toString()}/courses-of-study/${courseOfStudy.id}`,
			courseOfStudy
		);
	}

	updateCourseOfStudySubject(courseOfStudy: CourseOfStudy, otherFieldOfStudy?: string): void {
		const cos: CourseOfStudy = courseOfStudy;
		cos.otherCourseOfStudy = otherFieldOfStudy ? otherFieldOfStudy : cos.otherCourseOfStudy;
		this.courseOfStudyDataSubject.next(cos);
	}

	updateCoursesOfStudySubject(coursesOfStudy: Array<CourseOfStudy>): void {
		this.coursesOfStudyDataSubject.next(coursesOfStudy);
	}

	getNonDegreeCoursesOfStudy(participantId: number, degreeObjective: number): Observable<Array<CourseOfStudy>> {
		return this.http.get<Array<CourseOfStudy>>(
			`participants/${participantId.toString()}/degree-objectives/${degreeObjective}/non-degree-courses-of-study`
		);
	}
}
